module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "title": "Preface"
    }
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('div', [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "d0e30",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Preface")])]), _c('a', {
    attrs: {
      "id": "d0e30",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e30",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e30",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e30",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("Many people ask how I find the homes I photograph. That’s not at all a problem. Every\n        architect, designer, furniture builder, contractor and decorator in the entire world wants\n        and needs to be published. It’s incredibly important to the health and growth of any\n        business. Consequently, I’m often inundated with PR packages from business people all over\n        the world. Sometimes I receive half a dozen packages a day from different designers wanting\n        me to see their work. And, frankly, I love seeing new material. But I can’t choose everyone,\n        so I have to be very selective. ")]), _vm._v(" "), _c('p', [_vm._v("In truth, thousands of log cabins are constructed each year and each of them offers\n        something unique. I chose homes for this book that were innovative. Many rustic homes today\n        are furnished with extraordinary traditional rustic furniture. In all honesty, every inch in\n        both of my homes is filled with some sort of rustic furniture and rustic accessories. But\n        for this book I wanted to show how rustic homes look with something other than rustic\n        furniture. Consequently, the homes contained in this book feature a wide variety of\n        furnishings, including modern, Arts and Crafts, European and other eclectic styles. But\n        there’s more to it than that. Many of the homes I’ve looked at and photographed lately are\n        monastic in appearance. In other words, they are not over-burdened with accessories and\n        furniture. Homes decorated in a simple style are often more relaxing and more intimate than\n        those with excessive furnishings and accessories. Simplicity often has a calming effect.\n        Further, less stuff in a home allows the visitor to appreciate the architecture and the few\n        items that are part of the setting. ")]), _vm._v(" "), _c('p', [_vm._v("One of the more delightful innovations in interior design (it’s not really an innovation;\n        it’s been around a long time but seems to be in favor at the moment) is textured walls. An\n        extra layer of plaster is applied on top of Sheetrock. The plaster is left to dry with a\n        rough, textured surface. Paint is then applied. Once dry, a glazing compound is applied to\n        the surface, adding depth and character. The walls then take on an old-world appearance,\n        sort of like a Tuscan villa or a Southwestern adobe compound. Frankly, I love it and have\n        done this to a few walls in my own home. But for a photographer it poses some subtle\n        problems. Sometimes dark “smudges” appear on the images and there is great inclination to\n        remove these “aberrations” from the photograph in Photoshop. But reason prevails and I\n        recognize this as part of the charm of the home. I just hope that no one thinks that I\n        didn’t clean my lens before making the photographs. ")]), _vm._v(" "), _c('p', [_vm._v("So, the homes offered in this book are paragons of uniqueness and character. I think the\n        homes shown here are on the cutting edge of rustic design. They are places that I enjoyed\n        spending time at and hated to leave when my work was done! ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Image of a cabin."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Preface",
      "src": "images/High0048.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "d0e30",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ee45c18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch01.vue
// module id = 75
// module chunks = 0